export default __webpack_public_path__ + "static/media/Padron_50Anniversary.7556c667.jpg";